var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('label',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"h-10 w-full mt-1 p-3 caret-slate-300 border rounded border-slate-300",attrs:{"type":_vm.inputType,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":_vm.onValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }